<!-- Clicking the backdrop area closes; clicking the image itself does not. -->
<div class="relative bg-black/90 flex items-center justify-center" style="min-height:200px;" (click)="close()">

  <!-- Plain glyph rather than mat-icon: this dialog is opened from several modules and
       must not depend on MatIconModule being imported wherever it is rendered. -->
  <button
    type="button"
    (click)="close(); $event.stopPropagation()"
    class="absolute top-2 right-2 z-10 w-9 h-9 rounded-full bg-black/60 text-white flex items-center justify-center hover:bg-black/80 transition-colors text-xl leading-none"
    aria-label="Close image">
    &times;
  </button>

  <img
    [src]="data.url"
    [alt]="data.caption || 'Inspection photo'"
    (click)="$event.stopPropagation()"
    style="max-width:90vw; max-height:82vh; object-fit:contain; display:block;" />

  <p *ngIf="data.caption"
     class="absolute bottom-0 left-0 right-0 px-4 py-2 text-xs text-white bg-black/60 text-center">
    {{ data.caption }}
  </p>

</div>
